import React from 'react';
import PaymentEditContainer from '../../containers/paymentmng/PaymentEditContainer';

const PaymentEditPage = () => {
  return <PaymentEditContainer />
};

export default PaymentEditPage;
